import React from 'react';
import { Heading, Button, ButtonAppearance, ButtonSize, useDeviceSize } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';

import { useQueryParams } from 'src/hooks/useQueryParams';

const MOBILE_SIZE = 480;

export const NoResults: React.FC = () => {
  const { clearAllQueryParams } = useQueryParams();
  const deviceSize = useDeviceSize();

  const handleClick = (e: React.MouseEvent): void => {
    e.preventDefault();
    clearAllQueryParams();
  };

  return (
    <div css={containerStyles} data-testid="no-results-container">
      <div css={contentContainerStyles}>
        <div css={emptyStateDescriptionStyles}>
          <Heading level={deviceSize <= MOBILE_SIZE ? 3 : 4} fontWeight={600}>
            We couldn’t find any matches
          </Heading>
          <span css={textStyles}>Try again with different search terms or clear filters.</span>
        </div>
        <div>
          <Button
            label="Clear filters"
            isResponsive={true}
            size={ButtonSize.MEDIUM}
            appearance={ButtonAppearance.PRIMARY}
            onClick={handleClick}
          />
        </div>
      </div>
    </div>
  );
};

const containerStyles = css({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  padding: `56px ${token('space.200')}`,
  border: `1px solid ${token('color.border.disabled')}`,
  borderRadius: '8px',
  gap: `${token('space.300')}`,
});

const contentContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: `${token('space.400')}`,
});

const emptyStateDescriptionStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: `${token('space.200')}`,
});

const textStyles = css({
  fontSize: '16px',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  lineHeight: '24px',
  color: 'black',

  [media.below.xs]: {
    fontSize: '18px',
    lineHeight: '28px',
  },
});
